import { Component, Input, OnInit, ViewChild, EventEmitter, Output } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { catchError, map, switchMap, take, tap } from 'rxjs/operators';
import { of } from 'rxjs';
// Migrated 1:1 from @nexato/nx-core-module (issue/components/selectForm/select-form-widget.component.ts, #683)
import { EditSelectable, EditSelectInputComponent } from '../../edit-select-form-control/edit-select-form-control.component';
import { ApolloService } from '../../../services/apollo.service';
import { Issue } from '../../../entities/issue/issue';
import { CommandService } from '../../../services/command/command.service';
import { CommandInput, CommandTemplate } from '../../../entities/commandTemplate/commandTemplate';
import { IssueStatus } from '../../../entities/issue/issue-status';

@Component({
  selector: 'nx-select-form-widget',
  templateUrl: './select-form-widget.component.html'
})
export class SelectFormWidgetComponent implements OnInit {

  @Output() reload = new EventEmitter<void>();
  @ViewChild('selectComponent') selectComponent: EditSelectInputComponent;

  public editMode: boolean = false;

  public commandTemplate: CommandTemplate;

  options: any[] = [
    {
      value: 0,
      label: 'UVV Hubarbeitsbühne DGUV 100-500 + 308-002'
    },
    {
      value: 1,
      label: 'UVV Telestapler Anbaugeräte BetrSichV, FEM'
    },
    {
      value: 2,
      label: 'UVV Flurfördergeräte DGUV V68'
    }
  ];
  selectedControl = new FormControl<any | null>(null);
  form = new FormGroup({
    selected: this.selectedControl
  });

  constructor(
    private commandService: CommandService
  ) {
  }


  ngOnInit(): void {
    // No-op: command loading is handled in ngOnChanges
    this.selectedControl.setValue({
      value: 0,
      label: 'UVV Hubarbeitsbühne DGUV 100-500 + 308-002'
    });
  }

  loadCommandTemaplate() {
    // const commandInput = new CommandInput();
    // commandInput.name = "issueChangeStatusCommand";
    // commandInput.addParameter('commandProviderId', this.issue.id);

    // this.commandService.getCommandByCommandInput(commandInput)
    //     .pipe(take(1))
    //     .subscribe(result => {
    //       this.commandTemplate = result.data.getCommandByCommandInput;
    //       this.setActiveState(this.commandTemplate);
    //       this.setStateOptions(this.commandTemplate);
    //       this.reload.emit();
    //     });
  }

  edit() {
    this.editMode = true;
    // if (this.activeStatus) {
    //   this.selectedControl.setValue(this.activeStatus.code);
    // }
  }

  save() {
    this.editMode = false;
    // if (this.selectedControl.value && this.activeStatus.code === this.selectedControl.value) {
    //   console.log('No change in status');
    //   return;
    // }
    // let commandInput = new CommandInput();
    // commandInput.name = this.commandTemplate.name;
    // commandInput.addParameter('commandProviderId', this.issue.id);
    // commandInput.addParameter('nextStatus', this.selectedControl.value);
    // this.commandService.sendCommand(commandInput, (result) => {
    //   this.loadCommandTemaplate();
    // });
  }

  cancel() {
    this.editMode = false;
  }

}
